/**
 * 文档批量操作
 * liangshan
 */
import React, { ReactElement, useCallback, useContext, useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";

import { Icons } from "@/components/Joyspace/Icon";
import { message, Dropdown, Button, Popover, Tooltip } from "antd";

import context, { useTranslation } from "@/components/Joyspace/context";

import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { IContextRender } from "@/components/Joyspace/components/List/ContextMenu";
import events from "@/components/Joyspace/context/events";
import { IPage, ICategory } from "../types";
import { getPermission } from "@/api/user";
import { setDragSelectItem } from "@/components/Joyspace/components/MoveDragger";
import { useNavigator } from "@/utils/NetworkCheck";
import { disableAll } from "loglevel";
import Menus from "./Menus";

export type Option = (props: {
  children: React.ReactElement | string;
  callbackOrModal?: (() => any) | ReactElement;
  type?: string;
  isAllow?: boolean;
  allowTips?: string;
}) => void;

export interface IProps {
  children?: ReactElement | ReactElement[];
  render: IContextRender<IPage> | undefined;
  categoryRender: IContextRender<ICategory> | undefined;
  batchRender: IContextRender<(ICategory | IPage)[]> | undefined;
  selecteds: Set<any>;
  select: (set: Set<any>) => void;
  callbackProps?: any;
}
function BatchControl(props: IProps) {
  const { selecteds, select, render, categoryRender, batchRender } = props;
  console.log("setDragSelectItem111selecteds", selecteds);
  const { onLine } = useContext<GlobalContextConfig>(GlobalContext);
  const { freshLeftTreeByFolderById } = useContext(context);
  const [menus, setMenus] = useState<any[]>([]);
  // eslint-disable-next-line max-params
  const getDisabledTip = (type: any, selectType: any, permissions: any = [], isPage = true) => {
    let tip = "无权限";
    switch (type) {
      case "move":
        // tip = lang('');
        tip = "仅所有者和可管理协作者可移动";
        break;
      case "delete":
        // tip = lang('');
        tip = "仅所有者和可管理协作者可删除";
        break;
      case "copy":
        // tip = lang('');
        tip = "仅可管理和可编辑协作者可复制";
        break;
      case "setName":
        // tip = lang('');
        tip = "仅可管理和可编辑协作者可设置";
        break;
      case "rename":
        // tip = lang('');
        tip = "仅可管理和可编辑协作者可重命名";
        break;
      case "clone":
        // tip = lang('');
        tip =
          permissions.indexOf("SECURES_OPEN") !== -1
            ? "文档已开启安全设置，您暂无权限创建副本"
            : "仅可管理和可编辑协作者可创建副本";
        break;
      // case 'securitySet':
      //     // tip = lang('');
      //     tip = '如需设置该选项，请先联系文件夹所有者修改安全设置。';
      //     break;
      case "shared":
        tip = "";
        if (useNavigator.onLine) {
          tip = isPage
            ? "文档已开启安全设置，您暂无权限分享"
            : "文件夹已开启安全设置，您暂无权限分享";
        }
        break;
      case "download":
        // tip = lang('');
        tip = "文档已开启安全设置，您暂无权限下载";
        break;
    }
    return tip;
  };
  const getPermission = (selecteds: any, type: any) => {
    return true;
  };
  useEffect(() => {
    // 设置Drag数据
    setDragSelectItem(selecteds);
    getControlsMenus();
  }, [selecteds]);
  useEffect(() => {
    return () => {
      // 清空Drag数据
      setDragSelectItem(new Set());
    };
  }, []);
  const create = (render: Function | undefined, callbackProps: any, selectType?: any) => {
    if (!render) {
      console.warn("传入render出错");
      return null;
    }
    const menus: any[] = [];
    const option: Option = ({
      children: name,
      callbackOrModal,
      isAllow = true,
      type,
      allowTips
    }) => {
      const item = selecteds.values();
      const { permissions } = item.next().value;
      const { data } = callbackProps;
      const tip = allowTips
        ? allowTips
        : getDisabledTip(type, selectType, permissions, !!data?.page_type);
      if (type === "copy" && selectType && selectType !== "file") {
        return;
      }
      menus.push({
        name,
        callbackOrModal,
        type,
        tip,
        disabled: !(isAllow && onLine)
      });
    };
    render(option, callbackProps);
    setMenus(menus);
  };

  function reload() {}
  function clearSelect() {
    select(new Set());
  }

  function checkType(selectArray: any) {
    let fileCount = 0;
    let folderCount = 0;
    selectArray.forEach((element: any) => {
      if (typeof element.page_type === "undefined") {
        folderCount++;
      } else {
        fileCount++;
      }
    });
    let selectType = "file";
    if (fileCount > 0 && folderCount === 0) {
      selectType = "file";
    } else if (fileCount > 0 && folderCount > 0) {
      selectType = "both";
    } else {
      selectType = "folder";
    }
    return selectType;
  }
  const getControlsMenus = () => {
    if (selecteds.size > 1) {
      const selectType = checkType(selecteds);
      const callbackProps = {
        data: selecteds,
        reload,
        clearSelect,
        freshLeftTreeByFolderById,
        ...props.callbackProps
      };
      create(batchRender, callbackProps, selectType);
      return;
    }
    if (selecteds.size === 1) {
      const item: any = [...selecteds][0];
      const callbackProps = {
        data: item,
        reload,
        clearSelect,
        freshLeftTreeByFolderById,
        ...props.callbackProps
      };
      let useRender;
      // 文件夹
      if (typeof item.page_type === "undefined") {
        useRender = categoryRender;
      } else {
        useRender = render;
      }
      create(useRender, callbackProps);
      return;
    }
    setMenus([]);
  };

  return menus && <Menus menus={menus} />;
}

export default BatchControl;
